import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
    constructor() {
    }
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const userToken = sessionStorage.getItem('user_token');
        console.log('📦 Token lu dans interceptor :', userToken); // 👈 Ajoute ceci

        if (userToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${userToken}`
                }
            });
        }
        return next.handle(request);
    }

}
